<template>
  <div>

    <template>
      <span v-if="yesText" v-html="cmpLabel"></span>
      <span style="margin-left:15px" v-if="!!helperText && !!label">
        <v-btn x-small fab 
          elevation="0"
          tabindex="-1"
          @click="_showHelperText">
          <v-icon>mdi-message-text</v-icon>
        </v-btn>
      </span>
    </template>
 
    <v-row style="align-items: center;">
      <v-col cols="12" md="12">

        <v-radio-group column
            v-bind="$attrs"
            v-on="$listeners"    
            v-model="cmpValue"
            :rules="rules">
          
          <v-radio
            :value="true"
            @change="_onYes()">
            <template slot="label">
              <div v-html="yesText ? yesText : label"></div>
              <span style="margin-left:15px" v-if="!!helperText && !(!!label)">
                <v-btn x-small fab 
                  elevation="0"
                  tabindex="-1"
                  @click="_showHelperText">
                  <v-icon>mdi-message-text</v-icon>
                </v-btn>
              </span>
            </template>
          </v-radio>

          <v-radio v-if="noText != undefined"
            :label="noText"
            :value="false"
            @change="_onNo()">
          </v-radio>
          
        </v-radio-group>
      </v-col>
    </v-row>
    
    <HelperDialog
      :helperText="helperText"
      :show="helperTextPopUpVisible"
      @close="_closeHelperText">
    </HelperDialog>

  </div>
</template>

<script>

  import HelperDialog from "./helper-dialog.vue"
  import generic from '@/shared/utils/generic.js';

  export default {
    name: 'YesNo',
    components: {
      HelperDialog
    },    
    inheritAttrs: false,
    props: {
      label: { type: String },
      helperText: { type: String },      
      yesText: { type: String },
      noText: { type: String },
      rules: { type: Array },
      value: { type: Boolean },
    },
    data() {
      return {
        helperTextPopUpVisible: false,
        isRequired: undefined,
      };
    },
    created() {
      this.isRequired = generic.isRequired(this.rules);
    },    
    methods: {
      _onYes() {
        this.$emit("input", true); 
      },
      _onNo() {
        this.$emit("input", false);
      },
      _showHelperText () { 
        this.helperTextPopUpVisible = !!this.helperText;
      },
      _closeHelperText() { 
        this.helperTextPopUpVisible = false;  
      },      
    },
    computed: {
      cmpValue: {
        get: function () { return this.value; },
        set: function (newValue) { this.$emit("input", newValue); 
        },
      },
      cmpLabel: {
        get() { return this.label + (this.isRequired ? ' *' : ''); },
      }      
    }
  };
</script>

<style lang="scss" scoped>

</style>